import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import { MessageBox } from "element-ui";
import { getToken, setToken, setUserName } from "@/utils/auth";
Vue.use(VueRouter);

let isCheckingCurrentUser = false;

async function preCheckCurrentUserBeforeDeclar(next) {
  if (isCheckingCurrentUser) {
    return true;
  }
  isCheckingCurrentUser = true;
  try {
    const baseUrl = process.env.VUE_APP_API_BASE_URL || "";
    const res = await fetch(`${baseUrl}/user/person/findByCurrentUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        userId: getToken() || "",
        authorization: sessionStorage.getItem("Authorization") || ""
      },
      body: JSON.stringify({})
    }).then((r) => r.json());

    if (Number(res && res.code) === 410) {
      const accessToken = sessionStorage.getItem("Authorization") || "";
      await MessageBox.alert(
        (res && res.msg) || "用户不存在",
        "提示",
        {
          confirmButtonText: "确定",
          type: "warning",
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false
        }
      );
      await store.dispatch("user/resetToken");
      window.location.href =
        process.env.VUE_APP_KW_AUTH_BASE_URL +
        "auth/doNationalSSOLogout?accessToken=" +
        accessToken +
        "&systemType=kwjfPersonClient";
      next(false);
      return false;
    }
    return true;
  } catch (error) {
    // 预校验异常不阻断既有流程，避免影响正常页面访问
    return true;
  } finally {
    isCheckingCurrentUser = false;
  }
}

const routes = [
    {
        path: "/",
        name: "login",
        component: () => import("../views/login/login.vue"),
        meta: {
            title: "登录"
        }
    },
  {
    path: "/stop",
    name: "stop",
    component: () => import("../views/stop.vue"),
    meta: {
      title: "申报截止"
    }
  },
  {
    path: "/auth-login",
    name: "auth-login",
    component: () => import("../views/login/auth-login.vue"),
    meta: {
      title: "登录"
    }
  },
    {
        path: '/',//根路径
        name: 'home',
        meta: {
            title: '北京市科委创新创业人才积分落户管理'
        },
        component: () => import('../views/index.vue'),//主布局组件
        children: [
            {
                path: 'process',//申报流程
                name: 'process',
                component: () => import('../views/process/index.vue'),
                meta: {
                    title: '申报流程'
                },
            },
            {//
                path: 'personal-declar',//个人申报
                name: 'personal-declar',
                component: () => import('../views/personal-declar/index.vue'),
                meta: {
                    title: '个人申报'
                },
            },
            {
                path: 'enter-jindu',//企业审核 
                name: 'enter-jindu',
                component: () => import('../views/personal-declar/jindu.vue'),
                meta: {
                    title: '企业审核'
                },

            }, {//
                path: 'new-declar',//个人申报-申请信息详情
                name: 'new-declar',
                component: () => import('../views/personal-declar/new-declar.vue'),
                meta: {
                    title: '个人申报'
                },
            }, {//
                path: 'new-dec-info-gu',//个人申报-申请信息详情
                name: 'new-dec-info-gu',
                component: () => import('../views/personal-declar/new-dec-info-gu.vue'),
                meta: {
                    title: '个人申报'
                },
            },
            {//
                path: 'new-dec-info-jiang',//个人申报-申请信息详情
                name: 'new-dec-info-jiang',
                component: () => import('../views/personal-declar/new-dec-info-jiang.vue'),
                meta: {
                    title: '个人申报'
                },
            },
            {//
                path: 'new-look-gu',//个人申报-申请信息详情
                name: 'new-look-gu',
                component: () => import('../views/personal-declar/new-look-gu.vue'),
                meta: {
                    title: '个人申报'
                },
            },
            {//
                path: 'new-look-jiang',//个人申报-申请信息详情
                name: 'new-look-jiang',
                component: () => import('../views/personal-declar/new-look-jiang.vue'),
                meta: {
                    title: '个人申报'
                },
            },
            {
                path: 'password',//修改密码 
                name: 'password',
                component: () => import('../views/password/index.vue'),
                meta: {
                    title: '修改密码'
                },
            }, {
                path: 'user-manual',//用户手册 
                name: 'user-manual',
                component: () => import('../views/user-manual/index.vue'),
                meta: {
                    title: '用户手册'
                },
            },
        ]
    },
]

const router = new VueRouter({
    mode: "history",
    base: "/kwjfPersonClient",
    routes
});

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }

    let token = store.getters.token;
    if (!token) {
        const authorization = sessionStorage.getItem("Authorization");
        const jfUserInfo = sessionStorage.getItem("jfUserInfo");
        if (authorization && jfUserInfo) {
            try {
                const jfUserInfoObj = JSON.parse(jfUserInfo);
                store.commit("user/SET_TOKEN", authorization);
                store.commit("user/SET_USERNAME", jfUserInfoObj.name || jfUserInfoObj.userName || jfUserInfoObj.uno || "");
                setToken(authorization);
                setUserName(jfUserInfoObj.name || jfUserInfoObj.userName || jfUserInfoObj.uno || "");
                token = authorization;
                if (to.name === "login" || to.path === "/") {
                    next({ path: "/process", replace: true });
                    return;
                }
            } catch (e) {
                sessionStorage.removeItem("Authorization");
                sessionStorage.removeItem("jfUserInfo");
            }
        }
    }

    if (to.name === "login" || to.name === "login-register" || to.name === "stop") {
        if (token) {
            next({ path: "/process", replace: true });
            return;
        }
        next();
        return;
    }

    if (to.name === "auth-login") {
        if (token) {
            next({ path: "/process", replace: true });
            return;
        }
        if (to.query.code) {
            sessionStorage.setItem("authInProgress", "true");
            sessionStorage.setItem("authCode", to.query.code);
            // 保存原始 state，重定向时用存下的 state，避免覆盖成 kwjfPersonClient 导致本该去别的系统的用户留在本系统
            if (to.query.state) {
                sessionStorage.setItem("authState", to.query.state);
            } else {
                sessionStorage.removeItem("authState");
            }
            next();
            return;
        }
        const authorization = sessionStorage.getItem("Authorization");
        const jfUserInfo = sessionStorage.getItem("jfUserInfo");
        if (authorization && jfUserInfo) {
            next({ path: "/process", replace: true });
            return;
        }
        const authInProgress = sessionStorage.getItem("authInProgress");
        const authCode = sessionStorage.getItem("authCode");
        if (authInProgress === "true" && authCode) {
            // 使用存下的 state，没有时才用 kwjfPersonClient
            const savedState = sessionStorage.getItem("authState") || "kwjfPersonClient";
            next({ path: "/auth-login", query: { code: authCode, state: savedState } });
            return;
        }
        // 如果没有 code 也没有认证信息，允许访问 auth-login 页面（由组件内部处理重定向）
        next();
        return;
    }

    if (!token) {
        next({ name: "login" });
        return;
    }

    const authorization = sessionStorage.getItem("Authorization");
    const jfUserInfo = sessionStorage.getItem("jfUserInfo");
    if (!authorization || !jfUserInfo) {
        store.dispatch("user/resetToken").then(() => {
            next({ path: "/", replace: true });
        });
        return;
    }

    // 进入系统内页（home 子路由）前先校验当前用户
    const isHomeChildRoute = to.matched.some((route) => route.name === "home");
    if (isHomeChildRoute) {
        const canContinue = await preCheckCurrentUserBeforeDeclar(next);
        if (!canContinue) {
            return;
        }
    }

    next();
});

export default router
